import React from "react";

import nary from "@/modules/nary";
import thousandsFormat from "@/modules/thousandsFormat";
import { assetImg } from "@/modules/moduleImporter";
import { IMachineGameResultHistoryProps } from "@/types/GameHistoryTypes";

import img_cross from "../../../assets/img/img_cross.png";

import "./index.scss";

export default class M29 extends React.Component<IMachineGameResultHistoryProps> {
	render() {
		const reversedHistory = this.props.history.slice(0).reverse();

		const { langdata, tickets } = this.props;

		const hasTickets = tickets && tickets.length > 0;

		//{angka: "horse,tiger,rat", periode: 11}
		return (this.props.type !== "ticket") ? (
			//History
			<div className="history-container m29-history">
				<div className="ticket-header">
					<div>{langdata["txt_m29_first"]}</div>
					<div>{langdata["txt_m29_middle"]}</div>
					<div>{langdata["txt_m29_last"]}</div>
				</div>

				{
					(this.props.lobbyDesktop ?
						reversedHistory.slice(0, 6).reverse() :
						reversedHistory.slice(0, 6)).map((historyItem, rowIdx) =>
						<div className="row" key={"GRH_m29_" + rowIdx}>
							{
								historyItem.angka.split(",").map((item, idx) =>
									assetImg("m29", item + ".svg", "GRH_m29_" + rowIdx + "_" + idx)
								)
							}
						</div>
					)
				}
			</div>
		) : (
			//Tickets
			<div className={"m29-ticket" + (this.props.mustSubmitTickets ? " must-submit" : "")}
				body-scroll-lock-ignore="true">

				{
					hasTickets && (
						<div className="ticket-header">
							<div>Type</div>
							<div>{langdata["txt_m29_first"]}</div>
							<div>{langdata["txt_m29_middle"]}</div>
							<div>{langdata["txt_m29_last"]}</div>
						</div>
					)
				}

				{
					hasTickets ?
						/* [
								["C 1D", ["ox", "tiger", "dragon"], 50000, 12345],
								["C 2D", ["dragon", "snake", ""], 100000, 12345],
								["1D", ["", "", "dragon"], 75000, 12345],
							]. */
						// {
						//	 bayar: 1000
						//	 idnomor: 4
						//	 periode: 1
						//	 prize: "4"
						//	 taruhan: 1000
						//	 tebak: "rat,horse,rooster"
						//	 tgldata: "2019-07-04T08:20:43.704Z"
						//	 total: 4000
						//	 type: "c3d1"
						//	 user: "TESTUSERB"
						//	 userid: 4
						// }

						tickets.map((ticketItem, rowIdx) => {
							const ary = ticketItem.tebak.split(",");

							//How to align right arrays:
							let splitTebak = ["", "", ...ary.filter(item => item !== "")];
							splitTebak = splitTebak.slice(splitTebak.length - 3, splitTebak.length);

							return (
								<div className="row" key={"GRH_m29_ticket_" + rowIdx}>
									<div className="top">
										<div className="ticket-number">
											{rowIdx + 1}
										</div>

										<div className="ticket-type">
											{
												(ticketItem.type[0] === "c" ? "Colok " : "") +
												ticketItem.type[1] + "D"
											}
										</div>

										<div className="animals">
											{
												nary(3).map((item, idx) => {
													//Display animals
													const splitItem = splitTebak[idx];

													//Todo: nudge splitItem
													//[pig] --> [, , pig]
													//[rooster, dog] --> [, rooster, dog]

													return splitItem !== "" ?
														assetImg("m29", splitItem + ".svg",
															"GRH_m29_ticket_" + rowIdx + "_" + idx) :
														<div className="empty"
															key={"GRH_m29_ticket_" + rowIdx + "_" + idx}>
															{"\u00a0"}
														</div>;
												})
											}
										</div>

										{
											//After Rebet, shows a big cross emoji
											this.props.mustSubmitTickets &&
												<img className="remove-ticket"
													src={img_cross}
													alt="Remove ticket"

													{...{
														index: rowIdx,
														pcode: this.props.pcode
													}}

													onClick={this.props.removeTicket} />
										}
									</div>

									<div className="bottom">
										<div>BET: {thousandsFormat(ticketItem.taruhan, langdata.language_code)}</div>
										<div>PERIODE: {ticketItem.periode}</div>
									</div>
								</div>
							);
						}) : <div className="no-tickets">
							{langdata["txt_no_tickets"]}
						</div>
				}
			</div>
		);
	}
}